export type DisplayMode = 'standalone' | 'browser';

/** O app da Tela de Início do iOS não responde à media query `display-mode`; lá vale `navigator.standalone`. */
export function detectarDisplayMode(): DisplayMode {
  const rodaEmStandalone =
    (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) ||
    navigator.standalone === true;

  return rodaEmStandalone ? 'standalone' : 'browser';
}
